export default {
  middleware_url: "https://wip.bayle.fluid-it.fr",
  cake_url: "https://wip.cake.bayle.fluid-it.fr",
  isWavesoftEnabled: false,
  isUrbantzEnabled: false,
  billingConforamaEnabled: false,
};
